<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span class="text-3xl">💼</span>
        <span>典型职业详解</span>
      </h2>
      <p class="text-gray-600 text-lg">深入了解{{ typeName }}的代表性职业</p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div
        v-for="(career, index) in careers"
        :key="index"
        class="relative rounded-xl border transition-all hover:shadow-lg"
        :class="index === 0 ? 'border-2' : 'border'"
        :style="{
          padding: '24px',
          background: index === 0 ? `linear-gradient(135deg, ${typeColor}10, #ffffff)` : '#fafbfc',
          borderColor: index === 0 ? typeColor + '40' : '#e5e7eb',
          display: 'flex',
          flexDirection: 'column'
        }"
      >
        <!-- 热门推荐标签 -->
        <div
          v-if="index === 0"
          class="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold text-white"
          :style="{ backgroundColor: typeColor }"
        >
          热门推荐
        </div>

        <!-- 职业标题 -->
        <h4 
          class="text-lg font-semibold mb-3"
          :style="{ color: index === 0 ? typeColor : '#1f2937' }"
        >
          {{ career.title }}
        </h4>

        <!-- 职业描述 -->
        <p class="text-sm leading-relaxed text-gray-600 mb-4 flex-1">
          {{ career.description }}
        </p>

        <!-- 要求信息 -->
        <div class="pt-4 border-t border-gray-200 space-y-2">
          <div class="flex items-center gap-2">
            <span class="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded">学历要求</span>
            <span class="text-xs text-gray-600">{{ career.education }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="px-2 py-1 bg-green-100 text-green-700 text-xs rounded font-medium">薪资范围</span>
            <span class="text-xs text-gray-600">{{ career.salary }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 典型职业详解组件
 * 展示该类型的代表性职业及详细信息
 */
export default {
  name: 'TypicalCareers',
  props: {
    careers: {
      type: Array,
      required: true
    },
    typeName: {
      type: String,
      required: true
    },
    typeColor: {
      type: String,
      required: true
    }
  }
}
</script>

